// import { Routes } from '@angular/router';

import {
  // COMMON
  Page404LayoutComponent,
} from '@net7/boilerplate-common';
import {
  // MURUCA
  MrHomeLayoutComponent,
  MrSearchLayoutComponent,
  MrStaticLayoutComponent,
  MrResourceLayoutComponent,
  // OTHER
  LocaleDependenciesGuard,
  MrAdvancedSearchLayoutComponent,
  MrAdvancedResultsLayoutComponent
} from '@net7/boilerplate-muruca';
import { MapLayoutComponent } from './layouts/map-layout/map-layout';
import { LeafletMapsLayoutComponent } from './layouts/leaflet-maps-layout/leaflet-maps-layout';

// const NOT_FOUND_PATH = 'page-404';
type RouteConfig = {
  component?: any;
  paths: {
    [locale: string]: string;
  };
  data?: any;
  isRedirect?: boolean;
  redirectTo?: {
    [locale: string]: string;
  };
}

const config: {
  [layoutID: string]: RouteConfig;
} = {
  works: {
    component: MrSearchLayoutComponent,
    paths: {
      it: 'works',
      en: 'en/works',
      es: 'es/works'
    },
    data: { configId: 'search-works' },
  },
  work: {
    component: MrResourceLayoutComponent,
    paths: {
      it: 'work/:id/:slug',
      en: 'en/work/:id/:slug',
      es: 'es/work/:id/:slug'
    },
    data: { configId: 'resource-work' }
  },
  bibl_edition: {
    component: MrResourceLayoutComponent,
    paths: {
      it: 'edition/:id/:slug',
      en: 'en/edition/:id/:slug',
      es: 'es/edition/:id/:slug'
    },
    data: { configId: 'resource-edition' }
  },
  bibl_sample: {
    component: MrResourceLayoutComponent,
    paths: {
      it: 'sample/:id/:slug',
      en: 'en/sample/:id/:slug',
      es: 'es/sample/:id/:slug'
    },
    data: { configId: 'resource-sample' }
  },
  bibl_record: {
    component: MrResourceLayoutComponent,
    paths: {
      it: 'record/:id/:slug',
      en: 'en/record/:id/:slug',
      es: 'es/record/:id/:slug'
    },
    data: { configId: 'resource-record' }
  },
  records: {
    component: MrSearchLayoutComponent,
    paths: {
      it: 'records',
      en: 'en/records',
      es: 'es/records'
    },
    data: { configId: 'search-records' },
  },
  characters: {
    component: MrSearchLayoutComponent,
    paths: {
      it: 'characters',
      en: 'en/characters',
      es: 'es/characters'
    },
    data: { configId: 'search-characters' },
  },
  character: {
    component: MrResourceLayoutComponent,
    paths: {
      it: 'character/:id/:slug',
      en: 'en/character/:id/:slug',
      es: 'es/character/:id/:slug'
    },
    data: { configId: 'resource-character' }
  },
  motifs: {
    component: MrSearchLayoutComponent,
    paths: {
      it: 'motifs',
      en: 'en/motifs',
      es: 'es/motifs'
    },
    data: { configId: 'search-motifs' },
  },
  motif: {
    component: MrResourceLayoutComponent,
    paths: {
      it: 'motif/:id/:slug',
      en: 'en/motif/:id/:slug',
      es: 'es/motif/:id/:slug'
    },
    data: { configId: 'resource-motif' }
  },
  places: {
    component: MrSearchLayoutComponent,
    paths: {
      it: 'places',
      en: 'en/places',
      es: 'es/places'
    },
    data: { configId: 'search-places' },
  },
  place: {
    component: MrResourceLayoutComponent,
    paths: {
      it: 'place/:id/:slug',
      en: 'en/place/:id/:slug',
      es: 'es/place/:id/:slug'
    },
    data: { configId: 'resource-place' }
  },
  mrc_character: {
    component: MrResourceLayoutComponent,
    paths: {
      it: 'mrc_character',
      en: 'mrc_character',
      es: 'mrc_character'
    },
    redirectTo:
    {
      it: 'character',
      en: 'en/character',
      es: 'es/character'
    },
    isRedirect: true,
    data: { configId: 'resource-character' }
  },
  mrc_place: {
    component: MrResourceLayoutComponent,
    paths: {
      it: 'mrc_place',
      en: 'mrc_place',
      es: 'esc_place'
    },
    redirectTo:
    {
      it: 'place',
      en: 'en/place',
      es: 'es/place'
    },
    isRedirect: true,
    data: { configId: 'resource-place' }
  },
  mrc_motif: {
    component: MrResourceLayoutComponent,
    paths: {
      it: 'mrc_motif',
      en: 'mrc_motif',
      es: 'esc_motif'
    },
    redirectTo:
    {
      it: 'motif',
      en: 'en/motif',
      es: 'es/motif'
    },
    isRedirect: true,
    data: { configId: 'resource-motif' }
  },
  news: {
    component: MrSearchLayoutComponent,
    paths: {
      it: 'news',
      en: 'en/news',
      es: 'es/news'
    },
    data: { configId: 'search-news' },
  },
  post: {
    component: MrStaticLayoutComponent,
    paths: {
      it: 'post/:slug',
      en: 'en/post/:slug',
      es: 'es/post/:slug',
    },
    data: { configId: 'post' }
  },
  advancedSearch: {
    component: MrAdvancedSearchLayoutComponent,
    paths: {
      it: 'advanced-search',
      en: 'en/advanced-search',
      es: 'es/advanced-search'
    },
    data: { configId: 'advanced-search' }
  },
  advancedResults: {
    component: MrAdvancedResultsLayoutComponent,
    paths: {
      es: 'es/results',
      it: 'results',
      en: 'en/results'
    },
    data: { configId: 'advanced-results' }
  },
  home: {
    component: MrHomeLayoutComponent,
    paths: {
      it: '',
      en: 'en/',
      es: 'es/'
    },
    data: { configId: 'home' }
  },
  homeRedirect: { paths: { en: 'en', es: 'es', }, isRedirect: true, },
  map: {
    component: MapLayoutComponent,
    paths: {
      it: 'map',
      en: 'en/map',
      es: 'es/map',
    },
    data: { configId: 'map' }
  },
  leafletMaps: {
    component: LeafletMapsLayoutComponent,
    paths: {
      it: 'leaflet-maps',
      en: 'en/leaflet-maps',
      es: 'es/leaflet-maps',
    },
    data: { configId: 'leaflet-maps' }
  },
  page: {
    component: MrStaticLayoutComponent,
    paths: {
      it: ':slug',
      en: 'en/:slug',
      es: 'es/:slug',
    },
    data: { configId: 'page' }
  },
  page404: { paths: { it: 'page-404', en: 'en/page-404' }, component: Page404LayoutComponent, data: { id: 'page-404' } }

};
/* export const APP_ROUTES: any = [
  { path: 'mrc_motif', redirectTo: 'motif' },
]; */

const APP_ROUTES: any = [
  {
    path: 'home',
    redirectTo: '',
    pathMatch: 'full'
  }
];

/**
 * Generate angular routes from config
 */
Object.keys(config).forEach((routeId) => {
  const {
    component, data, paths, isRedirect, redirectTo
  } = config[routeId];
  Object.entries(paths).forEach(([locale, path]) => {
    // path to component
    if (component) {
      APP_ROUTES.push({
        path,
        component,
        data: { ...data, routeId, locale },
        canActivate: [LocaleDependenciesGuard]
      });
    }
    // catch route
    if (isRedirect) {
      APP_ROUTES.push(
        {
          path,
          redirectTo: redirectTo ? redirectTo[locale] : `${path}/`,
          data: { ...data, routeId, locale },
        }
      );
    }
  });
});

// default route handler
/* APP_ROUTES.push(
  {
    path: '**',
    component: MrStaticLayoutComponent,
    data: {
      notFoundPath: NOT_FOUND_PATH,
      locale: 'it'
    },
    canActivate: [LocaleDependenciesGuard]
  },
  {
    path: NOT_FOUND_PATH,
    component: Page404LayoutComponent,
    data: { id: 'page-404', locale: 'it' },
    canActivate: [LocaleDependenciesGuard]
  }
); */

export { APP_ROUTES };
